
























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class DoKoImgBtn extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  src!: string;

  @Prop({
    type: String,
    default: "60px",
  })
  height!: string;

  get style() {
    return {
      height: this.height,
    };
  }
}
